import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
const Breadcrumb = forwardRef((props, ref) => {
  const { items, className, ...rest } = props;
  return /* @__PURE__ */ jsx("ul", { ...rest, "aria-label": "breadcrumb", ref, className: twMerge("flex items-center text-sm", className), children: items.map((item, i) => /* @__PURE__ */ jsx(
    "li",
    {
      className: twMerge(
        "hf-breadcrumb-item",
        "flex items-center text-grayscale-500 whitespace-nowrap overflow-hidden"
      ),
      children: i === items.length - 1 ? /* @__PURE__ */ jsx("span", { className: "truncate", children: item.label }) : /* @__PURE__ */ jsx("a", { className: "cursor-pointer hover:underline truncate", onClick: item.onClick, children: item.label })
    },
    i
  )) });
});
export {
  Breadcrumb as default
};
//# sourceMappingURL=Breadcrumb.js.map
